/**
 * The One Page Plan PDF is rendered off-origin by Nutrient from a bare HTML
 * string, so origin-relative bundler paths like `/build/_assets/foo-HASH.svg`
 * have no base to resolve against and silently fail to load (ELE-967). Absolute
 * public URLs are fine — the firm logo fetches from S3 — but a bundled asset
 * never gets one. Holding the artwork in-module and handing out a data URI
 * keeps the report and the in-app scorecard on one source with no fetch.
 *
 * Base64 rather than `encodeURIComponent`: both are correct, base64 is simply
 * the more compact of the two for this payload (14,872 vs 15,475 characters).
 */
const beachModeIllustrationSvg = `<svg width="216" height="140" viewBox="0 0 216 140" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_484_6724)">
    <path
      d="M0.000244141 76.7102H216V123.14C216 132.059 208.77 139.29 199.851 139.29H16.1498C7.23065 139.29 0.000244141 132.059 0.000244141 123.14V76.7102Z"
      fill="url(#paint0_linear_484_6724)"
    />
    <path
      d="M0.000244141 76.7102H216V123.14C216 132.059 208.77 139.29 199.851 139.29H16.1498C7.23065 139.29 0.000244141 132.059 0.000244141 123.14V76.7102Z"
      fill="url(#paint1_radial_484_6724)"
    />
    <path
      d="M0.000244141 76.7102H216V123.14C216 132.059 208.77 139.29 199.851 139.29H16.1498C7.23065 139.29 0.000244141 132.059 0.000244141 123.14V76.7102Z"
      fill="url(#paint2_radial_484_6724)"
    />
    <path
      d="M0.000244141 76.7102H216V123.14C216 132.059 208.77 139.29 199.851 139.29H16.1498C7.23065 139.29 0.000244141 132.059 0.000244141 123.14V76.7102Z"
      fill="url(#paint3_radial_484_6724)"
      fill-opacity="0.3"
    />
    <path
      d="M0.000244141 76.7102H216V123.14C216 132.059 208.77 139.29 199.851 139.29H16.1498C7.23065 139.29 0.000244141 132.059 0.000244141 123.14V76.7102Z"
      fill="url(#paint4_radial_484_6724)"
    />
    <path
      d="M0.000244141 76.7102H216V123.14C216 132.059 208.77 139.29 199.851 139.29H16.1498C7.23065 139.29 0.000244141 132.059 0.000244141 123.14V76.7102Z"
      fill="url(#paint5_linear_484_6724)"
      fill-opacity="0.05"
    />
    <g filter="url(#filter0_d_484_6724)">
      <path
        d="M21.1964 114.068C7.0656 114.068 10.0935 93.8813 -3.02784 93.8813C-16.1492 93.8813 -10.0933 95.9 -10.0933 95.9L1.00954 132.236H204.897L216 126.18V114.068H212.972C206.916 114.068 193.795 99.9374 173.608 99.9374C153.421 99.9374 118.094 121.134 101.944 121.134C85.7944 121.134 65.6075 107.003 50.4673 107.003C35.3272 107.003 35.3273 114.068 21.1964 114.068Z"
        fill="white"
      />
    </g>
    <g filter="url(#filter1_i_484_6724)">
      <path
        d="M14.1887 120.803C-0.302441 120.373 6.60396 97.1271 -6.85192 96.7274C-20.3078 96.3278 -14.1671 98.8552 -14.1671 98.8552L-4.03386 141.367L205.052 147.578L216.647 140.887L217.064 126.829L213.959 126.737C207.749 126.552 194.78 109.752 174.078 109.137C153.377 108.522 116.418 132.047 99.8567 131.555C83.2954 131.063 63.081 114.047 47.5548 113.586C32.0286 113.125 28.6798 121.233 14.1887 120.803Z"
        fill="url(#paint6_linear_484_6724)"
      />
    </g>
  </g>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M169.665 22.6916L166.977 29.0996L165.424 31.1764L167.184 32.2006L174.395 30.4376C174.776 29.7404 175.268 28.1442 174.188 27.3367C173.108 26.5293 170.722 23.9037 169.665 22.6916Z"
    fill="#18BF82"
  />
  <ellipse
    cx="173.15"
    cy="42.1306"
    rx="20.926"
    ry="15.0746"
    transform="rotate(14.9787 173.15 42.1306)"
    fill="white"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M169.664 22.6912L166.977 29.0992L165.424 31.1757L159.559 27.7616L161.979 22.8368C162.968 23.0152 165.89 23.2357 169.664 22.6912Z"
    fill="white"
  />
  <ellipse
    cx="150.323"
    cy="35.2501"
    rx="20.1489"
    ry="15.8253"
    transform="rotate(0.694154 150.323 35.2501)"
    fill="#18BF82"
  />
  <path
    d="M156.334 54.3096L161.049 55.9447L148.692 91.7637C146.773 93.1926 145.282 93.551 143.282 91.946L156.334 54.3096Z"
    fill="url(#paint7_linear_484_6724)"
  />
  <path
    d="M156.334 54.3096L161.049 55.9447L148.692 91.7637C146.773 93.1926 145.282 93.551 143.282 91.946L156.334 54.3096Z"
    fill="url(#paint8_radial_484_6724)"
  />
  <path
    d="M156.334 54.3096L161.049 55.9447L148.692 91.7637C146.773 93.1926 145.282 93.551 143.282 91.946L156.334 54.3096Z"
    fill="url(#paint9_linear_484_6724)"
  />
  <path
    d="M156.334 54.3096L161.049 55.9447L148.692 91.7637C146.773 93.1926 145.282 93.551 143.282 91.946L156.334 54.3096Z"
    fill="url(#paint10_radial_484_6724)"
  />
  <path
    d="M188.734 72.2736C175.947 67.3483 168.416 66.2598 154.558 66.2394C143.896 57.7602 137.289 54.4361 124.655 50.8858C122.653 43.7361 121.317 39.8613 115.321 35.208C135.919 17.4012 155.052 22.2084 168.854 27.073C182.657 31.9377 199.604 41.778 204.962 64.5332C197.692 65.09 194.261 67.109 188.734 72.2736Z"
    fill="#18BF82"
  />
  <path
    d="M188.734 72.2736C175.947 67.3483 168.416 66.2598 154.558 66.2394C143.896 57.7602 137.289 54.4361 124.655 50.8858C122.653 43.7361 121.317 39.8613 115.321 35.208C135.919 17.4012 155.052 22.2084 168.854 27.073C182.657 31.9377 199.604 41.778 204.962 64.5332C197.692 65.09 194.261 67.109 188.734 72.2736Z"
    fill="url(#paint11_radial_484_6724)"
    fill-opacity="0.2"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M167.02 26.4394C147.643 27.7126 137.777 32.7378 124.656 50.8863C124.656 50.8863 124.656 50.8863 124.656 50.8863C122.654 43.7366 121.318 39.8617 115.322 35.2084C135.022 18.178 153.382 21.8327 167.02 26.4394Z"
    fill="url(#paint12_linear_484_6724)"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M154.559 66.2398C168.417 66.2603 175.948 67.3488 188.735 72.274C188.735 72.2738 188.735 72.2737 188.735 72.2735C187.749 45.3363 181.993 37.9031 167.361 26.8758C166.282 29.8326 164.827 34.4556 162.981 40.3189C160.752 47.4001 157.953 56.2904 154.559 66.2398Z"
    fill="white"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M154.559 66.2398C168.417 66.2603 175.948 67.3488 188.735 72.274C188.735 72.2738 188.735 72.2737 188.735 72.2735C187.749 45.3363 181.993 37.9031 167.361 26.8758C166.282 29.8326 164.827 34.4556 162.981 40.3189C160.752 47.4001 157.953 56.2904 154.559 66.2398Z"
    fill="url(#paint13_radial_484_6724)"
    fill-opacity="0.2"
  />
  <ellipse
    cx="167.36"
    cy="26.8758"
    rx="2.26118"
    ry="1.50746"
    transform="rotate(20.7413 167.36 26.8758)"
    fill="#9A9A9A"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M165.605 25.6005C166.115 25.2063 167.01 25.1313 167.894 25.4662C168.817 25.8158 169.453 26.5077 169.533 27.1669C169.023 27.561 168.128 27.636 167.244 27.3012C166.321 26.9515 165.685 26.2596 165.605 25.6005Z"
    fill="#D9D9D9"
  />
  <defs>
    <filter
      id="filter0_d_484_6724"
      x="-11.4885"
      y="87.8253"
      width="235.564"
      height="44.4113"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dx="8.07477" dy="-6.05607"/>
      <feComposite in2="hardAlpha" operator="out"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0.498039 0 0 0 0 0.262745 0 0 0 0 0.164706 0 0 0 0.1 0"/>
      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_484_6724"/>
      <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_484_6724" result="shape"/>
    </filter>
    <filter
      id="filter1_i_484_6724"
      x="-15.5654"
      y="96.6846"
      width="232.63"
      height="54.9304"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dy="4.03738"/>
      <feGaussianBlur stdDeviation="6.05607"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0"/>
      <feBlend mode="normal" in2="shape" result="effect1_innerShadow_484_6724"/>
    </filter>
    <linearGradient
      id="paint0_linear_484_6724"
      x1="193.001"
      y1="134.666"
      x2="96.7208"
      y2="61.489"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#FFC250"/>
      <stop offset="1" stop-color="#FFB000"/>
    </linearGradient>
    <radialGradient
      id="paint1_radial_484_6724"
      cx="0"
      cy="0"
      r="1"
      gradientUnits="userSpaceOnUse"
      gradientTransform="translate(93.8695 79.738) rotate(11.31) scale(102.933 2083.67)"
    >
      <stop stop-color="#FFD868"/>
      <stop offset="0.657885" stop-color="#FFD868" stop-opacity="0"/>
    </radialGradient>
    <radialGradient
      id="paint2_radial_484_6724"
      cx="0"
      cy="0"
      r="1"
      gradientUnits="userSpaceOnUse"
      gradientTransform="translate(146.355 95.8878) rotate(-2.38594) scale(96.9813 18.3743)"
    >
      <stop stop-color="#E58C1F"/>
      <stop offset="0.739286" stop-color="#E38820" stop-opacity="0"/>
    </radialGradient>
    <radialGradient
      id="paint3_radial_484_6724"
      cx="0"
      cy="0"
      r="1"
      gradientUnits="userSpaceOnUse"
      gradientTransform="translate(178.654 80.7476) rotate(171.656) scale(76.5108 29.9482)"
    >
      <stop stop-color="#D7731C"/>
      <stop offset="1" stop-color="#D7731C" stop-opacity="0"/>
    </radialGradient>
    <radialGradient
      id="paint4_radial_484_6724"
      cx="0"
      cy="0"
      r="1"
      gradientUnits="userSpaceOnUse"
      gradientTransform="translate(27.2526 119.103) rotate(-5.07214) scale(171.25 1476.65)"
    >
      <stop stop-color="#FFD868"/>
      <stop offset="0.59375" stop-color="#FFD868" stop-opacity="0.0974867"/>
      <stop offset="0.657885" stop-color="#FFD868" stop-opacity="0"/>
    </radialGradient>
    <linearGradient
      id="paint5_linear_484_6724"
      x1="50.4675"
      y1="88.8224"
      x2="0.000251003"
      y2="93.8691"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#FFA631" stop-opacity="0"/>
      <stop offset="1" stop-color="#FFD460"/>
    </linearGradient>
    <linearGradient
      id="paint6_linear_484_6724"
      x1="71.563"
      y1="123.516"
      x2="71.7367"
      y2="159.842"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#9EFCE3"/>
      <stop offset="0.755137" stop-color="#1AD1A1"/>
    </linearGradient>
    <linearGradient
      id="paint7_linear_484_6724"
      x1="160.96"
      y1="56.2847"
      x2="151.313"
      y2="54.2522"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#A66459"/>
      <stop offset="0.588542" stop-color="#8A3F42"/>
      <stop offset="1" stop-color="#7B4230"/>
    </linearGradient>
    <radialGradient
      id="paint8_radial_484_6724"
      cx="0"
      cy="0"
      r="1"
      gradientUnits="userSpaceOnUse"
      gradientTransform="translate(161.03 56.1352) rotate(117.677) scale(1.3184 0.252208)"
    >
      <stop stop-color="#C18E80"/>
      <stop offset="0.993283" stop-color="#C18E80" stop-opacity="0"/>
    </radialGradient>
    <linearGradient
      id="paint9_linear_484_6724"
      x1="147.659"
      y1="81.9083"
      x2="149.143"
      y2="82.6437"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0.078125" stop-color="#7E4229"/>
      <stop offset="0.203125" stop-color="#7E4229" stop-opacity="0"/>
      <stop offset="0.317708" stop-color="#7F534A"/>
      <stop offset="0.442708" stop-color="#7E4229" stop-opacity="0"/>
      <stop offset="0.502604" stop-color="#7E4229"/>
    </linearGradient>
    <radialGradient
      id="paint10_radial_484_6724"
      cx="0"
      cy="0"
      r="1"
      gradientUnits="userSpaceOnUse"
      gradientTransform="translate(143.274 92.0029) rotate(-63.6469) scale(1.10618 0.177038)"
    >
      <stop stop-color="#7E4321"/>
      <stop offset="0.993283" stop-color="#7E4321" stop-opacity="0"/>
    </radialGradient>
    <radialGradient
      id="paint11_radial_484_6724"
      cx="0"
      cy="0"
      r="1"
      gradientUnits="userSpaceOnUse"
      gradientTransform="translate(158.499 53.4538) rotate(82.875) scale(18.2302 38.2691)"
    >
      <stop/>
      <stop offset="1" stop-opacity="0"/>
    </radialGradient>
    <linearGradient
      id="paint12_linear_484_6724"
      x1="161.5"
      y1="24.5"
      x2="121.5"
      y2="39.5"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="white"/>
      <stop offset="1" stop-color="#CCCCCC"/>
    </linearGradient>
    <radialGradient
      id="paint13_radial_484_6724"
      cx="0"
      cy="0"
      r="1"
      gradientUnits="userSpaceOnUse"
      gradientTransform="translate(181.112 60.9914) rotate(61.3895) scale(18.8884 16.4039)"
    >
      <stop stop-color="#5C3E30"/>
      <stop offset="1" stop-color="#5C3E30" stop-opacity="0"/>
    </radialGradient>
    <clipPath id="clip0_484_6724">
      <rect width="216" height="62.5794" fill="white" transform="translate(0.000244141 76.7102)"/>
    </clipPath>
  </defs>
</svg>`;

// Collapsing the source indentation trims ~13% of the encoded bytes. Safe here:
// the markup has no text nodes, CDATA or xml:space, and no attribute value spans
// a line break.
//
// This runs at module scope in a file three Scorecard components and the report
// template all import, so a throw here is an SSR 500 rather than a missing
// image. btoa alone rejects anything above U+00FF, which a single em dash or ©
// pasted in from a Figma re-export would introduce, so encode to bytes first.
const toBase64 = (input: string) =>
  btoa(String.fromCharCode(...new TextEncoder().encode(input)));

export const beachModeIllustrationDataUri = `data:image/svg+xml;base64,${toBase64(
  beachModeIllustrationSvg.replace(/\n\s*/g, ' ')
)}`;
